import { generateSpacingValues } from '../generators';
import { GumSpacings } from '../models';

export const padding: GumSpacings = {
  ...generateSpacingValues('padding'),
};
